import { Label } from '@/components/ui/label';

type TenantOption = { id: string; name: string };

export function ContactAgentTenantPicker({
  tenants,
  tenantId,
  onChange,
}: {
  tenants: TenantOption[];
  tenantId: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className='flex items-center gap-2'>
      <Label htmlFor='contact-agent-tenant' className='text-xs text-muted-foreground'>
        Tenant
      </Label>
      <select
        id='contact-agent-tenant'
        className='h-9 rounded-md border border-input bg-background px-3 text-sm'
        value={tenantId}
        onChange={event => onChange(event.target.value)}
      >
        {tenants.map(tenant => (
          <option key={tenant.id} value={tenant.id}>
            {tenant.name}
          </option>
        ))}
      </select>
    </div>
  );
}
